import React from 'react';
import {
    Box,
    Card,
    CardContent,
    CircularProgress,
    Typography
} from '@material-ui/core';
import Intent from './Intent';

const MyRecordings = (props) => {
    const { voiceFiles, isLoading, intents, setCurrentRecording } = props;
    const getUrl = (fileName) => {
        let url;
        for (let i = 0; i < voiceFiles.length; i++) {
            const voiceFileName = voiceFiles[i].name.substring(0, voiceFiles[i].name.indexOf("_alexa"));
            if (voiceFileName === fileName) {
                url = voiceFiles[i].url;
            } 
        }
        return url;
    };

    return (
        <Card>
            <CardContent>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Typography color="textPrimary" gutterBottom variant="h3">
                        My Recordings
                    </Typography>
                </Box>
                <Box alignItems="center" display="flex" flexDirection="column">
                { 
                    isLoading ?
                    <CircularProgress color="primary" /> :
                    ( 
                        intents.length ?
                        intents.map((intent, index) => 
                            <Intent
                                intentName={intent}
                                key={index}
                                url={getUrl(intent.substring(0, intent.indexOf(".mp3")))}
                                setCurrentRecording={setCurrentRecording}
                                index={index}
                            />
                        ) :
                        <Typography color="textSecondary" gutterBottom variant="h5">
                            You don't have any recordings yet. Uploaded tracks will appear here.
                        </Typography>
                    )
                }
                </Box>
            </CardContent>
        </Card>
    );
};

export default MyRecordings;
